import type {RouteRecordRaw} from "vue-router";

// TODO(permissão): colaborador e grupo de permissão ainda sem `meta.permissao` — o usuário vai informar os
// códigos reais (funções 0833–0841 do backend, ainda não cadastradas em TB_FUNCAO). Ver Playbook 7.
export const colaboradorRoutes: RouteRecordRaw[] = [
    {
        path: "/colaborador",
        name: "colaborador",
        meta: {authRequired: true},
        component: () => import("@/modules/colaborador/pages/PageColaborador.vue")
    },
    {
        path: "/colaborador/grupo-permissao",
        name: "grupo-permissao",
        meta: {authRequired: true},
        component: () => import("@/modules/colaborador/pages/PageGrupoPermissao.vue")
    },
];
